/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import { MenuItem, TextField } from '@material-ui/core';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { DrugActivityGridColData } from './gridComponent/TableHead';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  STATUS_MSG,
  SUCCESS_MSG,
} from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import { handleQuarterFormate } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import { dispatchFullScrrenNdcHistory } from '../store/actions';

const NDCHistory = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  // use Selector function
  const requestNdcHistoryData = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.setNdcActivityHistory
  );
  const requestNdcHistoryHeaderData = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer?.setNDCHistoryHeader
  );
  const searchParams = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.disputeResolutionDetailObj
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const ndcHistoryGridFullScrren = useSelector(
    (state) =>
      state?.sharedState?.PerformDisputeResolutionReducer
        ?.ndcHistoryGridFullScrren
  );
  const [NDCHistoryList, setNDCHistoryList] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [fullScreenView, setFullScreenView] = useState(false);
  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
    dispatch(dispatchFullScrrenNdcHistory(fullScreenView));
  };
  // on gride ready functionality
  const onGridReady = (params) => {
    setGridApi(params?.api);
  };
  // setting Specific Audit Type List
  React.useEffect(() => {
    let list = [];
    if (
      requestNdcHistoryData &&
      requestNdcHistoryData.status === STATUS_MSG &&
      requestNdcHistoryData.message === SUCCESS_MSG
    ) {
      if (!_.isEmpty(requestNdcHistoryData?.ndcactivityHistory)) {
        list = _.map(requestNdcHistoryData?.ndcactivityHistory, (val, ind) => ({
          ...val,
          drugActivityTypeCd: val.drugActivityTypeCd,
          drugActivityDt: val.drugActivityDt,
          invoiceQtr: val.invoiceQtr,
          unitRebateAmt: val.unitRebateAmt,
          numOfUnits: val.numOfUnits,
          changeNumOfUnits: val.changeNumOfUnits,
          disputeCd: val.disputeCd,
          changeAmt: val.changeAmt,
        }));
      }
    }
    setNDCHistoryList(list);
  }, [requestNdcHistoryData]);
  return (
    <div
      className=" tabs-container tBillPanel custom-check"
      data-testid="ndc-history"
    >
      <Spinner load={spinnerLoader} />
      {!ndcHistoryGridFullScrren && (
        <CustomSeparator parent1="Tasks" parent2="NDC History" />
      )}

      {!ndcHistoryGridFullScrren && (
        <div className="row form-wrapper">
          <div className="col-12 col-sm-12 col-md-4 input-md mui-custom-form">
            <TextField
              data-testid="-textField"
              id="ndc-id"
              label="NDC"
              fullWidth
              disabled
              placeholder=""
              value={requestNdcHistoryHeaderData?.data?.ndc}
              inputProps={{ maxLength: 38, id: 'ndc-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className="col-12 col-sm-12 col-md-4 input-md mui-custom-form">
            <TextField
              data-testid="rebate-program-textField"
              id="rebate-program-id"
              label="Rebate Program"
              fullWidth
              disabled
              placeholder=""
              value={requestNdcHistoryHeaderData?.payload?.rebateProgramCd}
              inputProps={{ maxLength: 38, id: 'rebate-program-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className="col-12 col-sm-12 col-md-4 input-md mui-custom-form">
            <TextField
              data-testid="manufacturer-iD-textField"
              id="manufacturer-iD-id"
              label="Manufacturer ID"
              fullWidth
              disabled
              placeholder=""
              value={searchParams?.mfgID}
              inputProps={{ maxLength: 38, id: 'manufacturer-iD-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
          <div className="col-12 col-sm-12 col-md-4 input-md mui-custom-form">
            {searchParams?.mfgName &&
            searchParams?.mfgName !== '' &&
            searchParams?.mfgName.length > 25 ? (
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="labeler-tooltip">{searchParams.mfgName}</Tooltip>
                }
              >
                <TextField
                  data-testid="Name-textField"
                  id="Name-id"
                  label="Name"
                  fullWidth
                  disabled
                  placeholder=""
                  value={
                    searchParams.mfgName != null &&
                    searchParams.mfgName.length > 0
                      ? `${searchParams.mfgName.substring(0, 25)}...`
                      : ''
                  }
                  inputProps={{ maxLength: 38, id: 'Name-id' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </OverlayTrigger>
            ) : (
              <TextField
                data-testid="Name-textField"
                id="Name-id"
                label="Name"
                fullWidth
                disabled
                placeholder=""
                value={searchParams.mfgName}
                inputProps={{ maxLength: 38, id: 'Name-id' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          </div>
          <div className="col-12 col-sm-12 col-md-4 input-md mui-custom-form">
            <TextField
              data-testid="quarter-textField"
              id="quarter-id"
              label="Quarter"
              fullWidth
              disabled
              placeholder=""
              value={requestNdcHistoryHeaderData?.payload?.quarter}
              inputProps={{ maxLength: 38, id: 'quarter-id' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>

          <div className="col-12 col-sm-12 col-md-4 input-md mui-custom-form">
            {requestNdcHistoryHeaderData?.data?.drugName &&
            requestNdcHistoryHeaderData?.data?.drugName !== '' &&
            requestNdcHistoryHeaderData?.data?.drugName.length > 25 ? (
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="labeler-tooltip">
                    {requestNdcHistoryHeaderData?.data?.drugName}
                  </Tooltip>
                }
              >
                <TextField
                  data-testid="Name-textField"
                  id="drug-name-id-tooltip"
                  label="Drug Name"
                  fullWidth
                  disabled
                  placeholder=""
                  value={
                    requestNdcHistoryHeaderData?.data?.drugName != null &&
                    requestNdcHistoryHeaderData?.data?.drugName.length > 0
                      ? `${requestNdcHistoryHeaderData?.data?.drugName.substring(
                          0,
                          25
                        )}...`
                      : ''
                  }
                  inputProps={{ maxLength: 38, id: 'Name-id' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </OverlayTrigger>
            ) : (
              <TextField
                data-testid="Name-textField"
                id="drug-name-id"
                label="Drug Name"
                fullWidth
                disabled
                placeholder=""
                value={requestNdcHistoryHeaderData?.data?.drugName}
                inputProps={{ maxLength: 38, id: 'Name-id' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            )}
          </div>
        </div>
      )}
      <div className="row">
        <div className="col-sm-12 FRR-custom-table tbl-manufacturer-inner frr-log_chk">
          <TableGridWithFeatures
            data-testid="drug-Activity-grid"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={ndcHistoryGridFullScrren}
            handleFullScreenViewClick={handleFullScreenView}
            gridHeight={ndcHistoryGridFullScrren ? '70vh' : viewPortHeight_355}
            gridCall={onGridReady}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            exportFile
            animateRows
            sideBar={false}
            isScrollOn
            fileName="Drug Activity Grid"
            columnDefs={DrugActivityGridColData}
            rowData={NDCHistoryList}
            frameworkComponents={{
              changeAmtCellRender: (cellInfo) => {
                const isNegativeVal = !(
                  parseFloat(
                    cellInfo?.data?.changeAmt?.toString().split('$')[1]
                  ) >= 0
                );
                return (
                  <>
                    {isNegativeVal ? (
                      <div
                        style={{ color: 'red' }}
                      >{`(${cellInfo?.data?.changeAmt
                        ?.toString()
                        ?.replace('-', '')
                        .trim()})`}</div>
                    ) : (
                      <div>{`${cellInfo?.data?.changeAmt}`}</div>
                    )}
                  </>
                );
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default NDCHistory;
